<template>

    <v-card flat class="text-center" height="280">
     <v-card-text>
       <v-layout  wrap justify-center align-center>

         <v-flex xs12 text-center>
           <v-avatar size="100" color="accent">
             <v-icon size="50" color="white">
               fa-calendar-alt
             </v-icon>
           </v-avatar>
         </v-flex>

         <v-flex xs12>
           <v-divider class="my-2"></v-divider>
         </v-flex>

         <v-flex xs12 text-center>
           <div class="text-center mx-auto">
             <div class="headline">Total de citas</div>
             <div class="subheading">a la fecha</div>
             <div class="display-3">
               {{total}}
             </div>
           </div>
         </v-flex>
       </v-layout>
     </v-card-text>
    </v-card>

</template>

<script>
export default {
  name: "AppointmentsCounter",
  props:{
    total: {
      type: Number,
      default: 0
    }
  },
  components:{
  }
}
</script>

<style scoped>

</style>
